import React from 'react';
export default (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    fill="currentColor"
  >
    <style type="text/css">{'.st0{clip-path:url(#SVGID_2_);}'}</style>
    <g>
      <defs>
        <rect id="SVGID_1_" width="24" height="24" />
      </defs>
      <clipPath id="SVGID_2_">
        <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
      </clipPath>
      <g className="st0">
        <path
          className="st1"
          d="M5,14.8c1.1,0,2-0.9,2-2s-0.9-2-2-2c-1.1,0-2,0.9-2,2S3.9,14.8,5,14.8z M19,14.8c1.1,0,2-0.9,2-2s-0.9-2-2-2
			s-2,0.9-2,2S17.9,14.8,19,14.8z M20,15.8h-2c-0.5,0-1,0.2-1.4,0.6c1.3,0.7,2.2,1.9,2.3,3.4H21c0.6,0,1-0.4,1-1v-1
			C22,16.7,21.1,15.8,20,15.8z M12,15.8c1.9,0,3.5-1.6,3.5-3.5S13.9,8.8,12,8.8s-3.5,1.6-3.5,3.5S10.1,15.8,12,15.8z M14.4,16.8
			h-0.3c-0.7,0.3-1.4,0.5-2.1,0.5s-1.5-0.2-2.1-0.5H9.6c-2,0-3.6,1.6-3.6,3.6v0.9c0,0.8,0.7,1.5,1.5,1.5h9c0.8,0,1.5-0.7,1.5-1.5
			v-0.9C18,18.4,16.4,16.8,14.4,16.8z M7.4,16.4C7,16,6.6,15.8,6,15.8H4c-1.1,0-2,0.9-2,2v1c0,0.6,0.4,1,1,1h2.1
			C5.3,18.3,6.2,17.1,7.4,16.4z"
        />
        <path
          className="st1"
          d="M11.4,0.8c0.2-0.4,0.8-0.4,0.9,0l0.4,1.3c0.1,0.2,0.3,0.3,0.5,0.3l1.4,0c0.5,0,0.7,0.6,0.3,0.9l-1.1,0.8
			c-0.2,0.1-0.2,0.3-0.2,0.5L14,6c0.1,0.5-0.4,0.8-0.8,0.6l-1.1-0.8c-0.2-0.1-0.4-0.1-0.6,0l-1.1,0.8C10.1,6.8,9.6,6.4,9.7,6
			l0.4-1.3c0.1-0.2,0-0.4-0.2-0.5L8.8,3.3C8.5,3,8.6,2.4,9.1,2.4l1.4,0c0.2,0,0.4-0.1,0.5-0.3L11.4,0.8z"
        />
      </g>
    </g>
  </svg>
);
